module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic12.63aae01b.png";